export enum AssociationFormSections {
  mainInformation = 'mainInformation',
  funStuffSizes = 'funStuffSizes',
  address = 'address',
  dietaryConsiderations = 'dietaryConsiderations',
  flightPreference = 'flightPreference',
}

export const ASSOCIATION_FORM_TABS = [
  { id: AssociationFormSections.mainInformation, title: 'Main Info', template: 'mainInfoItemTmp' },
  { id: AssociationFormSections.funStuffSizes, title: 'Fun Stuff Sizes', template: 'funStuffSizesItemTmp' },
  { id: AssociationFormSections.address, title: 'Address', template: 'addressItemTmp' },
  { id: AssociationFormSections.dietaryConsiderations, title: 'Dietary Considerations', template: 'dietaryConsiderationsItemTmp' },
  { id: AssociationFormSections.flightPreference, title: ' Preferred Airlines ', template: 'flightPreferenceItemTmp' },
];
